import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TimelineEvent } from '@app-shared/components/ng-vertical-timeline/timeline-event';
import { environment } from '@env/environment';
import { UtilService } from '@app-shared/services/util.service';
import { AdminService } from '@app/admin/admin.service';
import { ApiService } from '@app/shared/services/api.service';
import { URL } from '@app-shared/constants/service-urls';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ng-vertical-timeline',
    templateUrl: './ng-vertical-timeline.component.html',
    styleUrls: ['./ng-vertical-timeline.component.scss'],
    standalone: false
})


export class NgVerticalTimelineComponent implements OnInit {
  @Input()
  data: { [key: string]: TimelineEvent[] };
  @Input()
  primaryColor: string;
  showBreadcrumbs: boolean = false;
  currentRoute: string;
  tableName: string = 'Roles ';
  tableName1: string = 'Role Revision History ';
  tableName2: string = 'User Category Revision History ';
  tableName3: string = 'User Revision History ';
  Home: string = 'Home ';
  UerCategory: string = 'User Category ';
  User: string = 'User ';
  orgmou: string = 'Org-mou ';
  orgList: string = 'Org-List ';
  orgmou2: string = 'Org-mou Revision History';
  orgmou3: string = 'Org-List Revision History';
  orgmou1: string = 'admin';
  orgmou4: string = 'Org-admin Revision History';
  deals: string = 'Deals ';
  dealsHistory: string = 'Deal Revision History ';
  opportunities: string = 'Opportunities ';
  opportunitiesHistory: string = 'Opportunity Revision History ';
  sortedData: any[] = [];
  showFilterBox = false;
  userSearch = '';
  filteredUserList: string[] = [];
  selectedUser: string = '';
  dateFilterType: 'exact' | 'range' = 'exact';
  exactDate: string = '';
  startDate: string = '';
  endDate: string = '';
  selectedDateRange: string = '';
  activeFilterCount = 0;
  pageTitle: string = '';

  // Cache for changed rules comparison
  private changedRulesCache: { [key: string]: { oldChanged: string[], newChanged: string[] } } = {};

  // Language translations for question revision history
  languageTranslations: any[] = [];
  languageMap = {
    1: 'English',
    2: 'Hindi',
    3: 'Tamil',
    4: 'Telugu',
    5: 'Kannada',
    6: 'Gujarati',
    7: 'Oriya',
    8: 'Assamese',
    9: 'Urdu',
    10: 'Marathi',
    11: 'Malayalam',
    12: 'Bengali',
    13: 'Punjabi',
    14: 'Manipuri'
  };

  private originalData: any = null;

  formatCustomDate(dateString: string): string {
    if (!dateString) return '';

    try {
      // Extract only the date part (before time if present)
      let dateOnly = dateString;
      
      // Handle ISO format: "2026-02-06T15:30:45" -> "2026-02-06"
      if (dateString.includes('T')) {
        dateOnly = dateString.split('T')[0];
      }
      // Handle format with space: "2026-02-06 15:30:45" -> "2026-02-06"
      else if (dateString.includes(' ')) {
        dateOnly = dateString.split(' ')[0];
      }
      // Handle other separators
      else if (dateString.match(/\d{4}-\d{2}-\d{2}[^\d]/)) {
        dateOnly = dateString.match(/\d{4}-\d{2}-\d{2}/)[0];
      }

      const date = new Date(dateOnly);
      if (isNaN(date.getTime())) return dateString;

      const day = date.getDate();
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const year = date.getFullYear();

      const getOrdinalSuffix = (d: number) => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      };

      return `${day}${getOrdinalSuffix(day)} ${monthNames[date.getMonth()]} ${year}`;
    } catch {
      return dateString;
    }
  }

 
  formatGroupKeyDateTime(key: string): string {
    if (!key) return '';
    const colonIndex = key.indexOf(':');
    if (colonIndex === -1) return this.formatCustomDate(key);

    const dateTimePart = key.substring(colonIndex + 1).trim();
    const [datePart, timePart] = dateTimePart.split(' ');
    const formattedDate = this.formatCustomDate(datePart);

    if (!timePart) return formattedDate;

    try {
      const [hours, minutes] = timePart.split(':').map(Number);
      const d = new Date();
      d.setHours(hours, minutes, 0, 0);
      const formattedTime = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
      return `${formattedDate}, ${formattedTime}`;
    } catch {
      return formattedDate;
    }
  }

  formatDateAsSimple(dateString: string): string {
    if (!dateString) return '';

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    } catch {
      return dateString;
    }
  }
  isModifiedDateLabel(label: string): boolean {
    if (!label) return false;
    
    const lowerLabel = label.toLowerCase();
    return lowerLabel.includes('modified_datetime') || 
          lowerLabel.includes('modified_date') || 
          lowerLabel.includes('modified date');
  }

  getCreatedUserName(events: TimelineEvent[]): string {
    if (!events || !Array.isArray(events)) return '';

    for (const event of events) {
      if (event.title === 'Created') {
        const userName = this.extractCreatedUserName(event.content) || event.user;
        if (userName) return userName;
      }
    }

    return '';
  }

  getCreatedOrganizationName(events: TimelineEvent[]): string {
    if (!events || !Array.isArray(events)) return '';

    for (const event of events) {
      if (event.title === 'Created') {
        const orgName = this.extractCreatedOrganizationName(event.content);
        if (orgName) return orgName;
      }
    }

    return '';
  }

  extractCreatedUserName(content: any): string {
    const extractFromObject = (data: any): string => {
      if (!this.isObject(data)) return '';
      if (data.created_user_name) return data.created_user_name;
      if (data.created_by) return data.created_by;
      if (data.created_user_username) return data.created_user_username;
      if (data.user_name) return data.user_name;
      if (data.username) return data.username;
      if (data.label && typeof data.label === 'string' && data.label.toLowerCase().includes('created user') && data.newValue) {
        return data.newValue;
      }
      return '';
    };

    const extractFromArray = (arr: any[]): string => {
      for (const item of arr) {
        if (typeof item === 'string') {
          const result = this.extractCreatedUserName(item);
          if (result) return result;
        } else if (Array.isArray(item)) {
          const result = extractFromArray(item);
          if (result) return result;
        } else if (this.isObject(item)) {
          const result = extractFromObject(item);
          if (result) return result;
          const nestedResult = this.extractCreatedUserName(item);
          if (nestedResult) return nestedResult;
        }
      }
      return '';
    };

    try {
      const data = typeof content === 'string' ? JSON.parse(content) : content;

      if (Array.isArray(data)) {
        return extractFromArray(data);
      }

      return extractFromObject(data);
    } catch (e) {
      return '';
    }
  }

  extractCreatedOrganizationName(content: any): string {
    const extractFromObject = (data: any): string => {
      if (!this.isObject(data)) return '';
      if (data.organization_name) return data.organization_name;
      if (data.organization) return data.organization;
      if (data.org_name) return data.org_name;
      if (data.organizationName) return data.organizationName;
      if (data.label && typeof data.label === 'string' && data.label.toLowerCase().includes('organization') && data.newValue) {
        return data.newValue;
      }
      return '';
    };

    const extractFromArray = (arr: any[]): string => {
      for (const item of arr) {
        if (typeof item === 'string') {
          const result = this.extractCreatedOrganizationName(item);
          if (result) return result;
        } else if (Array.isArray(item)) {
          const result = extractFromArray(item);
          if (result) return result;
        } else if (this.isObject(item)) {
          const result = extractFromObject(item);
          if (result) return result;
          const nestedResult = this.extractCreatedOrganizationName(item);
          if (nestedResult) return nestedResult;
        }
      }
      return '';
    };

    try {
      const data = typeof content === 'string' ? JSON.parse(content) : content;

      if (Array.isArray(data)) {
        return extractFromArray(data);
      }

      return extractFromObject(data);
    } catch (e) {
      return '';
    }
  }
  isFileLink(value: any): boolean {
    if (!value || typeof value !== 'string') return false;

    // Check if it's a URL that contains file paths
    const fileUrlPattern = /https?:\/\/[^\s]+\/(logo|mou|file|attachment|document|image|pdf)\//i;
    const fileExtensionPattern = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|jpg|jpeg|png|gif|bmp|svg|txt)$/i;

    return fileUrlPattern.test(value) || fileExtensionPattern.test(value);
  }


  constructor(
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private util: UtilService,
    private adminService: AdminService,
    private api: ApiService,
  ) { }

  ngOnInit() {
    (window as any).angularComponent = this;

    const breadcrumbData = this.activatedRoute.snapshot.data['breadcrumb'];

    if (Array.isArray(breadcrumbData) && breadcrumbData.length > 0) {
      this.pageTitle = breadcrumbData[breadcrumbData.length - 1].label;
    } else {
      this.pageTitle = this.activatedRoute.snapshot.data['nameTitle'] || 'Revision History';
    }

    // Get language translations from window.history.state (for Question Revision History)
    const navigationState = (window.history.state as any);
    if (navigationState && navigationState.languageTranslations && navigationState.languageTranslations.length > 0) {
      this.languageTranslations = navigationState.languageTranslations;
      console.log('📋 Captured language translations from state:', this.languageTranslations);
      console.log('📋 Parent ID:', navigationState.parentId);
      console.log('📋 Question ID:', navigationState.questionId);
    } else {
      console.log('⚠️ No language translations found in state');
      this.languageTranslations = [];
    }

    this.activatedRoute.data.subscribe((data) => {
      const rawEvents = data.events;
      let processedData = this.sortByModifiedDate(rawEvents);

      // Add language translations to timeline if they exist
      if (this.languageTranslations && this.languageTranslations.length > 0) {
        // Extract initial creation records from audit log for each language
        const initialCreationData = this.extractInitialCreationDataFromAudit(rawEvents, this.languageTranslations);
        processedData = this.addLanguageTranslationsToTimeline(processedData, initialCreationData);
      }

      this.data = processedData;
      this.cdr.markForCheck();
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects.toLowerCase();
        this.showBreadcrumbs = currentUrl.includes('usersettings');
        this.cdr.markForCheck();
      }
    });

    this.currentRoute = this.router.url;

    setTimeout(() => {
      this.setupSeeMoreListeners();
      this.setupHierarchyTreeListeners();
    }, 100);
  }
getSafeCreatedContent(content: any): any {
  const formatted = this.formatCreatedContent(content);
  return this.sanitizer.bypassSecurityTrustHtml(formatted);
}

setupHierarchyTreeListeners() {
  // Use global event delegation on document for hierarchy chevron clicks
  const handleChevronClick = (event: Event) => {
    const target = event.target as HTMLElement;
    
    // Check if clicked element is a hierarchy chevron
    if (target.classList.contains('hierarchy-chevron')) {
      event.preventDefault();
      event.stopPropagation();
      
      const labelId = target.getAttribute('data-label-id');
      if (labelId) {
        // Find the hierarchy container
        const container = target.closest('.hierarchy-container');
        if (container) {
          // Find all hierarchy-children divs with this parent-id
          const childrenContainers = container.querySelectorAll(`.hierarchy-children[data-parent-id="${labelId}"]`);
          
          childrenContainers.forEach((childContainer) => {
            const isHidden = (childContainer as HTMLElement).style.display === 'none';
            (childContainer as HTMLElement).style.display = isHidden ? 'block' : 'none';
          });
          
          // Toggle chevron icon
          const isCollapsed = target.textContent?.trim() === '▶';
          target.textContent = isCollapsed ? '▼' : '▶';
        }
      }
    }
  };
  
  // Remove existing listeners if any
  document.removeEventListener('click', handleChevronClick, true);
  // Add listener with capture phase for reliability
  document.addEventListener('click', handleChevronClick, true);
}

  setupSeeMoreListeners() {
    const seeMoreLinks = document.querySelectorAll('.see-more-link');
    seeMoreLinks.forEach(link => {
      const hiddenDiv = link.parentNode?.querySelector('.hidden-rules') as HTMLElement;
      if (hiddenDiv) {
        hiddenDiv.style.display = 'none';
        (link as HTMLElement).style.color = '#007bff';
      }

      link.addEventListener('click', (event) => {
        event.preventDefault();
        const hiddenDiv = link.parentNode?.querySelector('.hidden-rules') as HTMLElement;

        if (hiddenDiv) {
          const isHidden = hiddenDiv.style.display === 'none' || hiddenDiv.style.display === '';
          hiddenDiv.style.display = isHidden ? 'block' : 'none';
          link.textContent = isHidden ? 'See Less -' : 'See More +';
          (link as HTMLElement).style.color = '#007bff';
        }
      });
    });
  }

  sortByModifiedDate(groupedData: any): any {
    const sorted: any = {};

    Object.keys(groupedData).forEach((key) => {
      const events = groupedData[key];

      if (Array.isArray(events)) {
        let sortedEvents = events.sort((a, b) => {
          const aTime = this.getModifiedTime(a.content) || this.extractDateFromEvent(a) || 0;
          const bTime = this.getModifiedTime(b.content) || this.extractDateFromEvent(b) || 0;
          return bTime - aTime; // descending (newest first)
        });
        sorted[key] = this.removeDuplicateCreated(sortedEvents);
      } else {
        sorted[key] = events;
      }
    });

    return sorted;
  }

  private extractDateFromEvent(event: any): number {
    if (event.date) {
      return new Date(event.date).getTime();
    }

    // Try to find date in content
    if (event.content && Array.isArray(event.content)) {
      for (const item of event.content) {
        if (item.label && item.label.toLowerCase().includes('date') && item.newValue) {
          const date = new Date(item.newValue);
          if (!isNaN(date.getTime())) {
            return date.getTime();
          }
        }
      }
    }

    return 0;
  }

  private extractInitialCreationDataFromAudit(groupedData: any, languageTranslations: any[]): any {
    /**
     * Extract the initial creation record from audit log for each language question.
     * This ensures we show the values that were actually created, not the latest updated values.
     */
    const initialCreationMap: { [languageId: number]: any } = {};

    languageTranslations.forEach((translation: any) => {
      if (translation.language_id && translation.question_id) {
        // Find the creation event for this question_id in the audit log
        for (const [key, events] of Object.entries(groupedData)) {
          if (Array.isArray(events)) {
            for (const event of events) {
              if (event.title === 'Created') {
                try {
                  const createdData = typeof event.content === 'string'
                    ? JSON.parse(event.content)
                    : event.content;

                  // Match by question_id
                  if (createdData && createdData.id === translation.question_id) {
                    initialCreationMap[translation.language_id] = createdData;
                    break;
                  }
                } catch (e) {
                  // Continue if parsing fails
                }
              }
            }
          }
        }
      }
    });

    return initialCreationMap;
  }

  private addLanguageTranslationsToTimeline(groupedData: any, initialCreationData?: any): any {
    const result = { ...groupedData };

    // Get the user name from the CREATED event if available
    let createdEventUserName = '';
    for (const [key, events] of Object.entries(groupedData)) {
      if (Array.isArray(events)) {
        for (const event of events) {
          if (event.title === 'Created') {
            const userName = this.extractCreatedUserName(event.content);
            if (userName) {
              createdEventUserName = this.capitalizeFirstLetter(userName);
              break;
            }
          }
        }
      }
      if (createdEventUserName) break;
    }

    // Add language translations as separate timeline events
    if (this.languageTranslations && this.languageTranslations.length > 0) {
      // Track previous timestamps for each language to show old vs new
      const languageTimestamps: { [key: number]: string } = {};

      this.languageTranslations.forEach((translation: any) => {
        // Process ALL languages including English (language_id = 1) for consistent Created display
        const modifiedDate = translation.modified_datetime || translation.created_datetime;
        const createdDate = translation.created_datetime;
        const languageName = this.languageMap[translation.language_id] || 'Unknown Language';

          // Use the user name from the CREATED event
          let eventUserName = createdEventUserName;

          if (!eventUserName) {
            // Try to extract from translation object
            eventUserName = this.extractCreatedUserName(translation);
            if (eventUserName) {
              eventUserName = this.capitalizeFirstLetter(eventUserName);
            } else {
              // Fallback: get from localStorage username
              const storedUsername = localStorage.getItem('username');
              eventUserName = storedUsername ? this.capitalizeFirstLetter(storedUsername) : 'System';
            }
          }

          // Get the old timestamp for this language (if it was updated before)
          const oldTimestamp = languageTimestamps[translation.language_id] || null;

          // Determine if this is a creation or update
          // It's a creation if there's no old value (first time this language is added)
          const isCreation = oldTimestamp === null;

          // For creation events, use createdDate; for updates use modifiedDate
          const eventTimestamp = isCreation ? createdDate : modifiedDate;

          const formattedDate = this.formatDateTimeForBox(eventTimestamp);
          // Extract just the date part (29th Jan 2026) without time for grouping
          const dateOnlyPart = formattedDate.split(',')[0].trim();

          const eventKey = `${eventUserName}:${dateOnlyPart}`;

          // Update the timestamp tracker for this language
          languageTimestamps[translation.language_id] = modifiedDate;

          // Get the initial creation data for this language (if available)
          const initialData = initialCreationData && initialCreationData[translation.language_id];

          // Build the content array for the timeline event
          let eventContent = [];

          if (isCreation) {
            // For creation, use the INITIAL creation data from audit log, not the current data
            const dataToUse = initialData || translation;

            if (languageName) {
              eventContent.push({
                label: 'Language',
                oldValue: null,
                newValue: languageName
              });
            }
            if (dataToUse.question_text) {
              eventContent.push({
                label: 'Question Text',
                oldValue: null,
                newValue: dataToUse.question_text
              });
            }
            // Add created datetime with proper format
            if (createdDate) {
              eventContent.push({
                label: 'Created Datetime',
                oldValue: null,
                newValue: this.formatDateTimeForBox(createdDate)
              });
            }
          } else {
            // For updates, show old vs new values
            eventContent = [
              {
                label: 'Language',
                oldValue: languageName,
                newValue: languageName
              },
              {
                label: 'Question Text',
                oldValue: null,
                newValue: translation.question_text
              },
              {
                label: 'Modified Date&Time',
                oldValue: oldTimestamp ? this.formatDateTimeForBox(oldTimestamp) : null,
                newValue: this.formatDateTimeForBox(modifiedDate)
              }
            ];
          }

          // Create the timeline event - as "Created" for first addition, "Updated" for subsequent changes
          const languageEvent = {
            title: isCreation ? 'Created' : 'Updated',
            content: eventContent,
            date: eventTimestamp,
            user: eventUserName
          };

          // Add to result
          if (!result[eventKey]) {
            result[eventKey] = [];
          }
          result[eventKey].push(languageEvent);
      });
    }

    // Sort after adding new events
    return this.sortByModifiedDate(result);
  }

  private getModifiedTime(content: any): number {
    if (!Array.isArray(content)) {
      return 0;
    }

    const mod = content.find((c: any) =>
      c.label?.toLowerCase().includes('modified date')
    );

    if (!mod?.newValue) return 0;

    return new Date(mod.newValue).getTime();
  }

  formatFieldName(field: string): string {
    return field.replace(/_/g, ' ').replace(/(?:^|\s)\S/g, a => a.toUpperCase());
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  getFilteredChanges(content: any[]): any[] {
    if (this.currentRoute.includes('Roles/')) {
      return content;
    }

    if (this.currentRoute.includes('UserCategory/')) {
      return content.filter(con => {
        if (con.oldValue === con.newValue) return false;
        if (con.oldValue == null && con.newValue == null) return false;
        if (con.oldValue === '' && con.newValue === '') return false;

        if (typeof con.oldValue === 'object' || typeof con.newValue === 'object') {
          return JSON.stringify(con.oldValue) !== JSON.stringify(con.newValue);
        }

        return true;
      });
    }

    return content;
  }

  hasRealChanges(change: any): boolean {
    if ((!change.oldValue && !change.newValue) ||
      (change.oldValue === null && change.newValue === null) ||
      (change.oldValue === undefined && change.newValue === undefined)) {
      return false;
    }

    if ((change.oldValue == null && change.newValue != null) ||
      (change.oldValue != null && change.newValue == null)) {
      return true;
    }

    if (typeof change.oldValue === 'string' && typeof change.newValue === 'string') {
      return change.oldValue.trim() !== change.newValue.trim();
    }

    if (typeof change.oldValue === 'object' || typeof change.newValue === 'object') {
      return JSON.stringify(change.oldValue) !== JSON.stringify(change.newValue);
    }

    return change.oldValue !== change.newValue;
  }
  capitalizeFirstLetter(text: any): string {
  if (!text || typeof text !== 'string') return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}
  // Get formatted date and time for each event box
  getEventDateTime(item: any, groupKey: string = ''): string {
    try {
      if (item.date) {
        return this.formatDateTimeForBox(item.date);
      }

      let dateTimeStr = '';

      // Then try to get from the item content
      if (item.content && Array.isArray(item.content)) {
        const dateField = item.content.find((c: any) =>
          c.label?.toLowerCase().includes('date') && c.newValue
        );
        if (dateField?.newValue) {
          dateTimeStr = dateField.newValue;
        }
      }

      // If not found in content, try from group key
      if (!dateTimeStr && groupKey) {
        const parts = groupKey.split(':');
        if (parts.length > 1) {
          // Try to reconstruct date from group key
          // Group key format: "Priya:29th Jan 2026"
          const datePart = parts.slice(1).join(':');
          if (datePart) {
            return datePart; // Already formatted as "29th Jan 2026"
          }
        }
      }

      // If still not found, try any date field in content
      if (!dateTimeStr && item.content && Array.isArray(item.content)) {
        for (const contentItem of item.content) {
          if (contentItem.newValue && this.isValidDate(contentItem.newValue)) {
            dateTimeStr = contentItem.newValue;
            break;
          }
        }
      }

      return this.formatDateTimeForBox(dateTimeStr);
    } catch (e) {
      console.error('Error getting event date time:', e);
      return 'Date not available';
    }
  }
  private isValidDate(dateString: string): boolean {
    if (!dateString) return false;
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  // Format date-time for display in boxes
  formatDateTimeForBox(dateTimeStr: string): string {
    if (!dateTimeStr) return '';
    const englishFormatRegex = /^(\d{1,2})(st|nd|rd|th)\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+\d{4}$/i;
    if (englishFormatRegex.test(dateTimeStr.trim())) {
      return dateTimeStr.trim();
    }
    // If date is already in DD/MM/YYYY, HH:mm:ss format, extract just the date part
    const ddmmRegex = /^\d{2}\/\d{2}\/\d{4}, \d{2}:\d{2}:\d{2}$/;
    if (typeof dateTimeStr === 'string' && ddmmRegex.test(dateTimeStr)) {
      const datePart = dateTimeStr.split(',')[0].trim();
      // Convert "DD/MM/YYYY" to "29th Jan 2026" format
      return this.convertDDMMYYYYToEnglishFormat(datePart);
    }

    try {
      const date = new Date(dateTimeStr);
      if (isNaN(date.getTime())) return dateTimeStr;

      // Format: "29th Jan 2026" (date only, no time)
      const day = date.getDate();
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const year = date.getFullYear();

      // Add ordinal suffix
      const getOrdinalSuffix = (d: number) => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      };

      return `${day}${getOrdinalSuffix(day)} ${monthNames[date.getMonth()]} ${year}`;
    } catch {
      return dateTimeStr;
    }
  }
  private convertDDMMYYYYToEnglishFormat(dateStr: string): string {
    try {
      const parts = dateStr.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // 0-indexed months
        const year = parseInt(parts[2], 10);

        const date = new Date(year, month, day);
        if (isNaN(date.getTime())) return dateStr;

        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const getOrdinalSuffix = (d: number) => {
          if (d > 3 && d < 21) return 'th';
          switch (d % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
          }
        };

        return `${day}${getOrdinalSuffix(day)} ${monthNames[month]} ${year}`;
      }
      return dateStr;
    } catch {
      return dateStr;
    }
  }

  // Get user name for each event box
  getEventUserName(item: any, groupKey: string = ''): string {
    try {
      let userName = '';

      // First try to get from the item content
      if (item.content) {
        if (item.title === 'Created') {
          // For Created events, extract from content
          userName = this.extractCreatedUserName(item.content);
          // if not found and content is an array, try to find created user entry
          if (!userName && Array.isArray(item.content)) {
            for (const c of item.content) {
              if (c && c.label && c.label.toLowerCase().includes('created user')) {
                userName = typeof c.newValue === 'string' ? this.stripHtmlTags(c.newValue) : c.newValue;
                break;
              }
              if (c && c.label && c.label.toLowerCase().includes('created user username')) {
                userName = typeof c.newValue === 'string' ? this.stripHtmlTags(c.newValue) : c.newValue;
                break;
              }
            }
          }
        } else if (item.title === 'Updated' && Array.isArray(item.content)) {
          // For Updated events, look for user fields in content
          for (const contentItem of item.content) {
            if (contentItem.label?.toLowerCase().includes('user') && contentItem.newValue) {
              userName = contentItem.newValue;
              break;
            }
          }
        }
      }

      // If not found in content, try from group key
      if (!userName && groupKey) {
        const parts = groupKey.split(':');
        if (parts.length > 0 && parts[0]) {
          userName = parts[0];
        }
      }

      // If still not found, use item user
      if (!userName && item.user) {
        userName = item.user;
      }

      return userName || 'Unknown User';
    } catch (e) {
      return 'Unknown User';
    }
  }

  formatObject(obj: any, indent: string = ''): string {
    if (!obj) return '';
    if (this.isObject(obj)) {
      let result = '';
      for (const [key, value] of Object.entries(obj)) {
        if (
          key.toLowerCase() === 'id' ||
          (key.toLowerCase().endsWith('id') && !key.toLowerCase().includes('name')) ||
          (key.toLowerCase().endsWith('ids') && !key.toLowerCase().includes('name'))
        ) {
          continue;
        }
        const isEvalCriteriaContext = this.currentRoute?.includes('EvaluationCriteriaRevisionHistory') ||
          this.currentRoute?.includes('QuestionPaperVersionRevisionHistory');
        if (isEvalCriteriaContext && Array.isArray(value) && value.every(v => v === null || typeof v !== 'object')) {
          const items = value.filter(v => v !== null && v !== undefined && v !== '');
          const rendered = items.map(v => this.formatValue(key, v)).join(', ');
          result += `${indent}${this.formatFieldName(key)}: ${rendered}\n`;
        } else if (typeof value === 'object' && value !== null) {
          result += `${indent}${this.formatFieldName(key)}:\n${this.formatObject(value, indent + '  ')}\n`;
        } else {
          result += `${indent}${this.formatFieldName(key)}: ${this.formatValue(key, value)}\n`;
        }
      }
      return result.trim().replace(/\n/g, '<br>');
    }
    if (Array.isArray(obj)) {
      if (obj.length === 0) return 'None';
      return obj.map(item => this.formatObject(item, indent + '  ')).join('\n');
    }
    return this.formatValue('', obj);
  }

  formatCreatedContent(content: any): string {
    try {
      // If content is an array (we create structured arrays for some creation events), render each entry
      if (Array.isArray(content)) {
        let formattedArr = '<div class="created-content">';
        // Check if this is a language translation creation (only shows Language, Question Text, Created Datetime)
        const isLanguageTranslationCreation = content.length <= 3 &&
          content.some(c => c.label === 'Language') &&
          content.some(c => c.label === 'Question Text');
        
        // Check if this is a label hierarchy creation (has Hierarchy Structure field)
        const isLabelHierarchyCreation = content.some(c => c.label === 'Hierarchy Structure');

        // Check if this is a QPV creation (has Assign Marks or Assign Grouping Criteria field)
        const isQPVCreation = content.some(c => c.label === 'Assign Marks' || c.label === 'Assign Grouping Criteria');

        // Check if this is an EvaluationCriteria creation (has Evaluation Parameter or Grading Criteria field)
        const isEvaluationCriteriaCreation = content.some(c => c.label === 'Evaluation Parameter' || c.label === 'Grading Criteria');

        content.forEach((c: any) => {
          const label = c.label ? this.formatFieldName(String(c.label)) : '';
          const oldVal = c.oldValue !== undefined ? this.formatValue(label, c.oldValue) : 'None';
          const newVal = c.newValue !== undefined ? (
            typeof c.newValue === 'string' && (c.newValue.includes('<br>') || c.newValue.includes('<div>') || c.newValue.includes('<pre>'))
              ? c.newValue
              : this.formatValue(label, c.newValue)
          ) : 'None';

          // For language translation creation or label hierarchy or QPV or EvaluationCriteria, only show the field label and new value
          if (isLanguageTranslationCreation || isLabelHierarchyCreation || isQPVCreation || isEvaluationCriteriaCreation) {
            formattedArr += `
              <div class="created-row">
                <span class="created-label">${label}: </span>
                <span class="created-value">${newVal}</span>
              </div>
            `;
          } else if (c.label === 'Custom Attribute') {
            // For custom attribute entries, only show the attribute content — no old/new value rows
            formattedArr += `
              <div class="created-row">
                <span class="created-label">${label}: </span>
                <span class="created-value">${newVal}</span>
              </div>
            `;
          } else {
            // For other creation events, show old value vs new value
            formattedArr += `
              <div class="created-row">
                <span class="created-label">${label}: </span>
                <span class="created-value">${newVal}</span>
              </div>
              <div class="created-row small-values">
                <span class="label">Old Value: </span>
                <span class="value">${oldVal}</span>
                <span style="margin-left:1rem;" class="label">New Value: </span>
                <span class="value">${newVal}</span>
              </div>
            `;
          }
        });
        formattedArr += '</div>';
        return formattedArr;
      }

      const data = typeof content === 'string' ? JSON.parse(content) : content;
      const isRolesRoute = this.currentRoute.includes('Roles/');
      const isUserCategoryRoute = this.currentRoute.includes('UserCategory/');
      const isAssessmentPlanRoute = this.currentRoute.includes('AssessmentPlan/');
      const isQuestionRoute = this.currentRoute.includes('Questions/') || this.currentRoute.includes('revision-history');
      const isLabelRoute = this.currentRoute.includes('label');
      const isDefaultAccessCreation = isRolesRoute && (data?.role_name === 'Default Access' || data?.role_name === 'Organization Admin');

      // Special simplified format for non-English question translations
      if (isQuestionRoute && this.languageTranslations && this.languageTranslations.length > 0 && data?.language_id !== undefined && data?.language_id !== 1) {
        let formatted = '<div class="created-content">';

        formatted += `
          <div class="created-row">
            <span class="created-label">🌐 New Language Translation Added: </span>
            <span class="created-value"><strong>${this.languageMap[data?.language_id] || 'Unknown Language'}</strong></span>
          </div>
        `;

        // Show all non-null, non-empty fields with old value as None
        const FIELDS_TO_SKIP = ['id', 'parent_id', 'default_language_question_id', 'version_id', 'created_user_id', 'organization_id', 'created_datetime', 'modified_user_id', 'modified_datetime', 'is_deleted', 'is_archived', 'is_active', 'labels', 'tags', 'attachments'];

        for (const [key, value] of Object.entries(data)) {
          // Skip null, undefined, empty strings, empty arrays, empty objects
          if (
            value === null ||
            value === undefined ||
            (typeof value === 'string' && value.trim() === '') ||
            (Array.isArray(value) && value.length === 0) ||
            (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
          ) {
            continue;
          }

          // Skip technical fields
          if (FIELDS_TO_SKIP.includes(key.toLowerCase())) {
            continue;
          }

          // Format the field name
          const fieldName = this.formatFieldName(key);
          let displayValue = this.formatValue(key, value);
          if (typeof displayValue === 'object' && displayValue.hasOwnProperty('changingThisBreaksApplicationSecurity')) {
            displayValue = displayValue.changingThisBreaksApplicationSecurity;
          }

          formatted += `
            <div class="created-row">
              <span class="created-label">${fieldName}: </span>
              <span class="created-value">${displayValue}</span>
            </div>
            <div class="created-row small-values">
              <span class="label">Old Value: </span>
              <span class="value">None</span>
              <span style="margin-left:1rem;" class="label">New Value: </span>
              <span class="value">${displayValue}</span>
            </div>
          `;
        }

        formatted += '</div>';
        return formatted;
      }

      if (this.isObject(data)) {
        let formatted = '<div class="created-content">';
        const TECHNICAL_FIELDS = ['created_by', 'modified_by', 'created_at', 'updated_at'];

        // Fields to skip in Created section for Assessment Plans
        const ASSESSMENT_SKIP_FIELDS = ['tags', 'rules', 'question_paper_id', 'qpv_selected', 'question_paper_name', 
                                         'question_paper_version', 'question_paper_categories', 'question_paper_version_name'];

        // Check if this is a label creation with the new structured format
        const isLabelCreationStructured = data?.hierarchy || (data?.['📋 HIERARCHY OVERVIEW'] !== undefined);

        for (const [key, value] of Object.entries(data)) {
          // Skip separator lines
          if (key.includes('════════════════════════════════════')) {
            continue;
          }

          // Skip empty section headers or skip them if value is empty
          if (value === '') {
            continue;
          }

          if (key.trim().toLowerCase() === 'modified_user_name' || key.trim().toLowerCase() === 'modified_datetime') {
            continue;
          }

          // Skip assessment-specific fields in Created section
          if (isAssessmentPlanRoute && ASSESSMENT_SKIP_FIELDS.includes(key.toLowerCase())) {
            continue;
          }

          // Handle group_candidates specially for Assessment Plan Created section
          if (isAssessmentPlanRoute && key === 'group_candidates' && value) {
            try {
              const meta = typeof value === 'string' ? JSON.parse(value) : value;
              const lines = [];
              if (meta.total !== undefined) lines.push(`Total: ${meta.total}`);
              if (meta.published !== undefined) lines.push(`Published candidates: ${meta.published}`);
              if (meta.added !== undefined) lines.push(`Added candidates: ${meta.added}`);
              if (meta.removed !== undefined) lines.push(`Removed candidates: ${meta.removed}`);
              if (lines.length > 0) {
                formatted += `<div class="created-row"><span class="created-label">Candidates: </span><span class="created-value">${lines.join('<br>')}</span></div>`;
              }
            } catch (e) { /* skip malformed value */ }
            continue;
          }

          if (key.trim().toLowerCase() === 'created_user_username') {
            formatted += `
              <div class="created-row">
                <span class="created-label">Created User Email: </span>
                <span class="created-value">${value}</span>
              </div>
            `;
            continue;
          }

          // Handle label hierarchy section
          if (key === 'hierarchy' && typeof value === 'string' && value.includes('📦')) {
            formatted += `
              <div class="created-row hierarchy-section" style="margin: 1rem 0;">
                <span class="created-label" style="font-weight: bold; color: #2563eb;">📋 Label Hierarchy:</span>
              </div>
              <pre class="hierarchy-tree" style="background-color: #f3f4f6; padding: 1rem; border-radius: 0.5rem; overflow-x: auto; font-family: monospace; border-left: 4px solid #2563eb;">${this.escapeHtml(value)}</pre>
            `;
            continue;
          }

          // Handle section headers for label creation
          if (key.includes(' CREATED INFORMATION') || key.includes('🏢 ORGANIZATION DETAILS') || 
              key.includes(' LABEL DETAILS') || key.includes('📊 LABELS CREATED')) {
            formatted += `
              <div class="created-row section-header" style="margin-top: 1.5rem; margin-bottom: 0.5rem;">
                <span class="created-label" style="font-weight: bold; font-size: 1.1em; color: #1f2937;">${key}</span>
              </div>
            `;
            continue;
          }

          // Handle labels_list (array of label objects)
          if (key === 'labels_list' && Array.isArray(value)) {
            formatted += `
              <div class="created-row">
                <span class="created-label"> Created Labels:</span>
              </div>
            `;
            value.forEach((label: any, index: number) => {
              formatted += `
                <div class="created-row" style="padding-left: 2rem; margin: 0.5rem 0; border-left: 3px solid #e5e7eb; padding: 0.75rem;">
                  <div style="margin-bottom: 0.25rem;"><strong>Label ${index + 1}:</strong> ${label.label_name || 'N/A'}</div>
                  <div style="font-size: 0.9em; color: #6b7280;">ID: ${label.label_id || 'N/A'} | Parent ID: ${label.parent_label_id || 'Root'} | Status: ${label.status || 'N/A'}</div>
                </div>
              `;
            });
            continue;
          }

          if (
            value === null ||
            value === undefined ||
            (typeof value === 'string' && value.trim() === '') ||
            (typeof value === 'string' && value.trim() === '[]') ||
            (Array.isArray(value) && value.length === 0) ||
            (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
          ) {
            continue;
          }
          // Skip technical fields and generic IDs, but allow meaningful fields like parent_question_id
          // version_id should be skipped since we show version_name instead
          const MEANINGFUL_ID_FIELDS = ['parent_question_id'];
          const shouldSkip = key === 'id' ||
            key === 'version_id' || // Hide version_id, show version_name instead
            (key.endsWith('_id') && !MEANINGFUL_ID_FIELDS.includes(key) && !isLabelRoute) ||
            key.endsWith('_ids') ||
            TECHNICAL_FIELDS.includes(key);
          if (shouldSkip) continue;

          if (
            this.currentRoute?.toLowerCase().includes('/user') &&
            (key === 'modified_user_name' || key === 'modified_datetime' || key === 'selected_modules_visibility')
          ) continue;

          // Handle file links in creation content
          let displayValue = this.formatValue(key, value);
          if (typeof displayValue === 'object' && displayValue.hasOwnProperty('changingThisBreaksApplicationSecurity')) {
            displayValue = displayValue.changingThisBreaksApplicationSecurity;
          }

          if (key === 'perm_levels' && isDefaultAccessCreation) {
            formatted += `
              <div class="created-row">
                <span class="created-label">${this.formatFieldName(key)}: </span>
                <span class="created-value">Full Access</span>
              </div>
            `;
          } else if (key === 'perm_levels' && isRolesRoute && value && Array.isArray(value) && value.length > 0) {
            formatted += `
              <div class="created-row">
                <span class="created-label">Added Permissions: </span>
                <span class="created-value">${this.formatPermissionsForCreation(value)}</span>
              </div>
            `;
          }
          else if (key === 'custom_attrs' && isUserCategoryRoute && value && Array.isArray(value) && value.length > 0) {
            formatted += `
              <div class="created-row">
                <span class="created-label">Custom Attributes: </span>
                <span class="created-value">${this.formatCustomAttributesForCreation(value)}</span>
              </div>
            `;
          } else if (key === 'labels' && isQuestionRoute) {
            const labelDisplay = this.formatQuestionLabelsForCreation(value);
            if (labelDisplay) {
              formatted += `
                <div class="created-row">
                  <span class="created-label">Labels: </span>
                  <span class="created-value">${labelDisplay}</span>
                </div>
              `;
            }
          } else if (isRolesRoute || isUserCategoryRoute || isLabelRoute ||
            (value !== null &&
              value !== undefined &&
              value !== '' &&
              !(Array.isArray(value) && value.length === 0))) {
            formatted += `
              <div class="created-row">
                <span class="created-label">${this.formatFieldName(key)}: </span>
                <span class="created-value">${displayValue}</span>
              </div>
            `;
          }
        }
        formatted += '</div>';
        return formatted;
      }
      return this.formatValue('', content);
    } catch (e) {
      return this.formatValue('', content);
    }
  }

  formatQuestionLabelsForCreation(labelsData: any): string {
    try {
      let parsed = labelsData;
      if (typeof labelsData === 'string') {
        parsed = JSON.parse(labelsData);
      }
      if (!Array.isArray(parsed) || parsed.length === 0) return '';

      const buildLabelTree = (labels: any[], parentId: any): string => {
        const children = labels.filter((l: any) => {
          const pid = l.parentLabelId !== undefined ? l.parentLabelId : l.parent_label_id;
          return pid === parentId;
        });
        if (!children.length) return '';
        return children.map((child: any) => {
          const name = child.labelName || child.label_name || '';
          const childId = child.labelId !== undefined ? child.labelId : child.label_id;
          const grandchildren = buildLabelTree(labels, childId);
          if (grandchildren) {
            return `<details style="margin-left:20px"><summary style="cursor:pointer;padding:2px 0">&#9675; ${name}</summary><div>${grandchildren}</div></details>`;
          }
          return `<div style="margin-left:20px;padding:2px 0">&#9675; ${name}</div>`;
        }).join('');
      };

      const groupLines: string[] = [];
      parsed.forEach((group: any) => {
        const labels = Array.isArray(group.labels) ? group.labels : [];
        if (!labels.length) return;
        const rootLabel = labels.find((l: any) => {
          const pid = l.parentLabelId !== undefined ? l.parentLabelId : l.parent_label_id;
          return pid === null || pid === undefined || l.level === 0;
        });
        if (rootLabel) {
          const rootId = rootLabel.labelId !== undefined ? rootLabel.labelId : rootLabel.label_id;
          const name = rootLabel.labelName || rootLabel.label_name || '';
          const subtree = buildLabelTree(labels, rootId);
          if (subtree) {
            groupLines.push(`<details style="margin-bottom:4px"><summary style="cursor:pointer;padding:2px 0;font-weight:500">&#9675; ${name}</summary><div>${subtree}</div></details>`);
          } else {
            groupLines.push(`<div style="padding:2px 0;font-weight:500">&#9675; ${name}</div>`);
          }
        }
      });
      return groupLines.length ? groupLines.join('') : '';
    } catch (e) {
      return '';
    }
  }

  // Helper method to escape HTML
  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }


  getSafeHtml(html: string): any {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  expandedPermissions: { [key: string]: { old: boolean; new: boolean } } = {};

  formatPermissions(permissions: string, key: string, type: 'old' | 'new'): any {
    if (!permissions || permissions === 'None') return 'None';

    if (!this.expandedPermissions[key]) {
      this.expandedPermissions[key] = { old: false, new: false };
    }

    const isExpanded = this.expandedPermissions[key]?.[type] || false;
    const shouldTruncate = this.shouldTruncatePermissions(permissions);

    let displayText = permissions;
    if (shouldTruncate && !isExpanded) {
      displayText = this.truncatePermissions(permissions);
    }

    let formatted = `<div class="permissions-list">`;

    if (this.currentRoute.includes('Roles/')) {
      try {
        const permData = typeof permissions === 'string' ? JSON.parse(permissions) : permissions;

        if (Array.isArray(permData)) {
          permData.forEach(item => {
            formatted += `<div class="permission-item">• ${this.formatPermissionItem(item)}</div>`;
          });
        } else if (this.isObject(permData)) {
          for (const [page, access] of Object.entries(permData)) {
            formatted += `<div class="permission-page">• ${page}: ${access}</div>`;
          }
        } else {
          formatted += `<div class="permission-item">• ${displayText}</div>`;
        }
      } catch (e) {
        formatted += `<div class="permission-item">• ${displayText}</div>`;
      }
    }
    else if (this.currentRoute.includes('UserCategory/')) {
      try {
        const attrs = typeof permissions === 'string' ? JSON.parse(permissions) : permissions;

        if (Array.isArray(attrs)) {
          attrs.forEach(attr => {
            formatted += `<div class="permission-item">• ${this.formatCustomAttribute(attr)}</div>`;
          });
        } else if (this.isObject(attrs)) {
          for (const [attrName, attrValue] of Object.entries(attrs)) {
            formatted += `<div class="permission-page">• ${attrName}: ${attrValue}</div>`;
          }
        } else {
          formatted += `<div class="permission-item">• ${displayText}</div>`;
        }
      } catch (e) {
        formatted += `<div class="permission-item">• ${displayText}</div>`;
      }
    }
    else {
      const sections = displayText.split(' - ');
      sections.forEach((section, sectionIndex) => {
      });
    }

    if (shouldTruncate && !isExpanded) {
      formatted += `<div class="see-more-container">
          <a class="see-more-link" 
             (click)="onSeeMoreClick('${key}', '${type}', $event)">
              See More +
          </a>
      </div>`;
    }

    formatted += '</div>';
    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }

  private formatPermissionItem(item: any): string {
    if (typeof item === 'string') return item;
    if (this.isObject(item)) {
      let parts = [];
      for (const [key, value] of Object.entries(item)) {
        parts.push(`${key}: ${value}`);
      }
      return parts.join(', ');
    }
    return JSON.stringify(item);
  }

  private formatCustomAttribute(attr: any): string {
    if (typeof attr === 'string') return attr;
    if (this.isObject(attr)) {
      let parts = [];
      for (const [key, value] of Object.entries(attr)) {
        parts.push(`${key}: ${value}`);
      }
      return parts.join(', ');
    }
    return JSON.stringify(attr);
  }

  private formatPermissionsForCreation(permissions: any[]): string {
    if (!permissions || !Array.isArray(permissions) || permissions.length === 0) {
      return 'None';
    }

    let formatted = '';

    permissions.forEach(permission => {
      if (this.isObject(permission)) {
        const name = permission.name || permission.text || 'Unknown';
        const access = permission.access || 'full';

        formatted += `• ${name} (${access})<br>`;

        if (permission.pages && Array.isArray(permission.pages) && permission.pages.length > 0) {
          permission.pages.forEach(page => {
            const pageName = page.name || page.text || page;
            const pageAccess = page.access || 'full';
            formatted += `&nbsp;&nbsp;- Pages: ${pageName} (${pageAccess})<br>`;
          });
        }

        if (permission.features && Array.isArray(permission.features) && permission.features.length > 0) {
          permission.features.forEach(feature => {
            const featureName = feature.name || feature.text || feature;
            const featureAccess = feature.access || 'full';
            formatted += `&nbsp;&nbsp;- Features: ${featureName} (${featureAccess})<br>`;
          });
        }
      } else {
        formatted += `• ${permission}<br>`;
      }
    });

    return formatted.trim();
  }

  private formatCustomAttributesForCreation(attrs: any[]): string {
    if (!attrs || !Array.isArray(attrs) || attrs.length === 0) {
      return 'None';
    }

    let formatted = '';

    attrs.forEach(attr => {
      if (this.isObject(attr)) {
        const label = attr.label || attr.labelName || 'Unknown';
        const isMandatory = attr.isMandatory ? 'Yes' : 'No';
        const isDeleted = attr.is_deleted ? 'Yes' : 'No';
        const attributeType = attr.attributeType || 'Text';
        const isValidationNeeded = attr.isValidationNeeded ? 'Yes' : 'No';

        formatted += `• ${label}<br>`;
        formatted += `&nbsp;&nbsp;- Label Name: ${label}<br>`;
        formatted += `&nbsp;&nbsp;- Is Deleted: ${isDeleted}<br>`;
        formatted += `&nbsp;&nbsp;- Is Mandatory: ${isMandatory}<br>`;
        formatted += `&nbsp;&nbsp;- Attribute Type: ${attributeType}<br>`;
        if (attr.isValidationNeeded !== null) {
          formatted += `&nbsp;&nbsp;- Is Validation Needed: ${isValidationNeeded}<br>`;
        }
      } else {
        formatted += `• ${attr}<br>`;
      }
    });

    return formatted.trim();
  }

  private formatCustomAttributesForUpdate(value: any): any {
    if (!value || value === 'None') return 'None';

    try {
      const parsedValue = typeof value === 'string' ? JSON.parse(value) : value;

      if (Array.isArray(parsedValue)) {
        let formatted = '<div class="custom-attributes-container">';

        parsedValue.forEach(attr => {
          if (this.isObject(attr)) {
            const label = attr.label || attr.labelName || 'Unknown';
            const isMandatory = attr.isMandatory ? 'Yes' : 'No';
            const isDeleted = attr.is_deleted ? 'Yes' : 'No';
            const attributeType = attr.attributeType || 'Text';
            const isValidationNeeded = attr.isValidationNeeded ? 'Yes' : 'No';

            formatted += '<div class="custom-attribute-group">';
            formatted += `<div class="custom-attribute-item">• ${label}</div>`;
            formatted += `<div class="custom-attribute-item">  - Label Name: ${label}</div>`;
            formatted += `<div class="custom-attribute-item">  - Is Deleted: ${isDeleted}</div>`;
            formatted += `<div class="custom-attribute-item">  - Is Mandatory: ${isMandatory}</div>`;
            formatted += `<div class="custom-attribute-item">  - Attribute Type: ${attributeType}</div>`;
            if (attr.isValidationNeeded !== null) {
              formatted += `<div class="custom-attribute-item">  - Is Validation Needed: ${isValidationNeeded}</div>`;
            }
            formatted += '</div>';
          } else {
            formatted += `<div class="custom-attribute-item">• ${attr}</div>`;
          }
        });

        formatted += '</div>';
        return this.sanitizer.bypassSecurityTrustHtml(formatted);
      }
    } catch (e) {
      return value;
    }

    return value;
  }

  onSeeMoreClick(key: string, type: 'old' | 'new', event: Event): void {
    event.preventDefault();
    if (!this.expandedPermissions[key]) {
      this.expandedPermissions[key] = { old: false, new: false };
    }
    this.expandedPermissions[key][type] = !this.expandedPermissions[key][type];
    this.cdr.markForCheck();
  }

  private truncatePermissions(text: string): string {
    const words = text.split(/\s+/);
    return words.length <= 50 ? text : words.slice(0, 50).join(' ') + '...';
  }

  private shouldTruncatePermissions(text: string): boolean {
    return text && text.split(/\s+/).length > 50;
  }

  permissionsToggleState: { [key: string]: boolean } = {};

  isExpanded(idx: number, type: 'old' | 'new'): boolean {
    return this.permissionsToggleState[`${type}_${idx}`] || false;
  }

  togglePermissions(idx: number, type: 'old' | 'new') {
    const key = `${type}_${idx}`;
    this.permissionsToggleState[key] = !this.permissionsToggleState[key];
  }

  getVisiblePermissions(value: string, idx: number, type: 'old' | 'new'): string[] {
    const lines = value.split('\n');
    return lines.slice(0, 5);
  }

  getHiddenPermissions(value: string, idx: number, type: 'old' | 'new'): string[] {
    const lines = value.split('\n');
    return lines.slice(5);
  }

  hasHiddenPermissions(value: string): boolean {
    return value.split('\n').length > 5;
  }

  togglePermissionExpand(key: string): void {
    this.expandedPermissions[key] = { old: false, new: false };
    this.cdr.markForCheck();
  }

  stripHtmlTags(html: string): string {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  }

  formatValue(field: string, value: any, key?: string, type?: 'old' | 'new'): any {
    if (value === null || value === undefined) return 'None';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';

    const fieldLower = field.toLowerCase();

    if (this.isFileLink(value)) {
      const strValue = value as string;
      if (strValue.startsWith('http')) {
        // Full URL: open directly in new tab — original behaviour, no API call needed
        return this.sanitizer.bypassSecurityTrustHtml(
          `<a href="${strValue}" target="_blank" class="file-link">View File</a>`
        );
      } else {
        // S3 key (e.g. "local/mou-1/file.pdf"): must fetch a signed URL first.
        // onclick works here because formatCreatedContent wraps output in getSafeCreatedContent
        // which bypasses Angular's sanitizer, preserving the onclick attribute.
        const escapedKey = strValue.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
        return this.sanitizer.bypassSecurityTrustHtml(
          `<a onclick="window.angularComponent.viewMouFile('${escapedKey}')" class="file-link" style="cursor:pointer;color:#1976d2;text-decoration:underline;">View File</a>`
        );
      }
    }


    if (fieldLower.includes('cust attr values')) {
      let cleanValue = typeof value === 'string' ? value.replace(/<[^>]*>/g, '') : value;

      if (typeof cleanValue === 'string') {
        const blocks = cleanValue.split(/Type:/).filter(b => b.trim() !== '');
        let formatted = '<div class="cust-attr-values-blocks">';
        blocks.forEach(b => {
          const lines = b.split(/Value:/);
          formatted += '<div class="cust-attr-block">';
          if (lines[0]) formatted += `<div>Type: ${lines[0].trim()}</div>`;
          if (lines[1]) formatted += `<div>Value: ${lines[1].trim()}</div>`;
          formatted += '</div>';
        });
        formatted += '</div>';
        return this.sanitizer.bypassSecurityTrustHtml(formatted);
      }

      if (Array.isArray(cleanValue)) {
        let formatted = '<div class="cust-attr-values-blocks">';
        cleanValue.forEach(attr => {
          formatted += '<div class="cust-attr-block">';
          if (attr.type) formatted += `<div>Type: ${attr.type}</div>`;
          if (attr.value) formatted += `<div>Value: ${attr.value}</div>`;
          formatted += '</div>';
        });
        formatted += '</div>';
        return this.sanitizer.bypassSecurityTrustHtml(formatted);
      }

      return cleanValue;
    }

    if (
      fieldLower.includes('instruction') ||
      fieldLower.includes('hint') ||
      fieldLower.includes('text') ||
      fieldLower.includes('description')
    ) {
      return this.stripHtmlTags(value);
    }

    if (fieldLower.includes('permissions') && key && type) {
      return this.formatPermissions(value, key, type);
    }

    if (this.isAssessmentPlanRoute() && fieldLower === 'rules') {
      return this.formatAssessmentRules(value).join('\n');
    }

    if (this.isusercetorgyRoute() && fieldLower === 'custom_attrs') {
      return this.formatCustomAttributesForDisplay(value).join('\n');
    }

    if (fieldLower === 'tags') {
      const isEvalCriteriaContext = this.currentRoute?.includes('EvaluationCriteriaRevisionHistory') ||
        this.currentRoute?.includes('QuestionPaperVersionRevisionHistory');
      if (isEvalCriteriaContext) {
        const parsed = (() => {
          if (!value) return [];
          if (Array.isArray(value)) return value;
          if (typeof value === 'string') {
            try { const p = JSON.parse(value); return Array.isArray(p) ? p : []; } catch (e) { return []; }
          }
          return [];
        })();
        if (parsed.length === 0) return 'None';
        const renderTag = (tag: any) => {
          const k = tag?.key || '';
          const v = (k && tag[k] != null) ? tag[k] : '';
          const t = tag?.type || '';
          const parts = [`Tag: ${k}`];
          if (v !== '') parts.push(`Value: ${v}`);
          if (t !== '') parts.push(`Type: ${t}`);
          return parts.join('<br>');
        };
        return parsed.map(renderTag).join('<br><br>');
      }
      if (!value || (Array.isArray(value) && value.length === 0)) return 'None';
      if (Array.isArray(value)) {
        return value.map(tag => {
          if (tag.key) return tag.key + (tag[tag.key] ? `: ${tag[tag.key]}` : '');
          if (tag.name) return tag.name;
          if (tag.id) return String(tag.id);
          return JSON.stringify(tag);
        }).join(', ');
      }
      return value.toString();
    }

    if (this.isObject(value)) return this.formatObject(value);
    if (Array.isArray(value)) {
      if (value.length === 0) return 'None';
      return value.map(item => this.formatObject(item)).join('\n');
    }
    if (fieldLower.includes('is_') || fieldLower.includes('active')) {
      return value ? 'Yes' : 'No';
    }
    if (fieldLower.includes('date') || fieldLower.includes('datetime')) {
      try {
        // If already formatted as DD/MM/YYYY, HH:mm:ss, return as-is
        const ddmmRegex = /^\d{2}\/\d{2}\/\d{4}, \d{2}:\d{2}:\d{2}$/;
        if (typeof value === 'string' && ddmmRegex.test(value)) return value;

        // For "Created Datetime" field in language translations, use full datetime format
        if (fieldLower.includes('created datetime')) {
          const date = new Date(value);
          if (isNaN(date.getTime())) return value;
          return date.toLocaleString();
        }

        const date = new Date(value);
        if (isNaN(date.getTime())) return value;
        // For UserCategory route, format as DD/MM/YYYY, HH:mm:ss (en-GB)
        if (this.isusercetorgyRoute()) {
          return date.toLocaleString('en-GB', { hour12: false });
        }
        return date.toLocaleString();
      } catch (e) {
        return value;
      }
    }
    return value.toString();
  }

  private formatCustomAttributesForDisplay(attrs: any): any {
    if (!attrs || attrs === 'None') return 'None';

    let formatted = `<div class="custom-attributes-container">`;

    if (typeof attrs === 'string' && attrs.includes('•')) {
      const items = attrs.split('•').filter(item => item.trim() !== '');

      items.forEach(item => {
        formatted += `<div class="custom-attribute-item">${item.trim()}</div>`;
      });
    }
    else {
      try {
        const parsedAttrs = typeof attrs === 'string' ? JSON.parse(attrs) : attrs;

        if (Array.isArray(parsedAttrs)) {
          parsedAttrs.forEach(attr => {
            if (typeof attr === 'string') {
              formatted += `<div class="custom-attribute-item">${attr}</div>`;
            } else {
              Object.entries(attr).forEach(([key, value]) => {
                const formattedKey = this.formatFieldName(key);
                formatted += `<div class="custom-attribute-item">${formattedKey}: ${value}</div>`;
              });
            }
          });
        }
        else if (typeof parsedAttrs === 'object') {
          Object.entries(parsedAttrs).forEach(([key, value]) => {
            const formattedKey = this.formatFieldName(key);
            formatted += `<div class="custom-attribute-item">${formattedKey}: ${value}</div>`;
          });
        }
        else {
          formatted += `<div class="custom-attribute-item">${attrs}</div>`;
        }
      } catch (e) {
        formatted += `<div class="custom-attribute-item">${attrs}</div>`;
      }
    }

    formatted += '</div>';
    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }

  private formatAttributeValue(value: any): string {
    if (value === null || value === undefined) return 'None';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (Array.isArray(value)) return value.join(', ');
    if (typeof value === 'object') return JSON.stringify(value);
    return value.toString();
  }

  navigatetab() {
    this.router.navigate(['/UserSettings/Roles']);
  }

  navigatetabs() {
    this.router.navigate(['/UserSettings/UserCategory']);
  }

  navigatetotab() {
    this.router.navigate(['/UserSettings/Users']);
  }

  navigateToEditOrg() {
    const selectedOrg = localStorage.getItem('SelectedOrgForRevision');
    if (selectedOrg) {
      const orgData = JSON.parse(selectedOrg);
      const encryptedOrgId = this.util.encrypt(orgData.id.toString());
      this.router.navigate(['/admin/org', encryptedOrgId]);
    } else {
      this.router.navigate(['/admin/org-list']);
    }
  }

  openMOUList() {
    const selectedOrg = localStorage.getItem('SelectedOrgForRevision');
    if (selectedOrg) {
      const orgData = JSON.parse(selectedOrg);
      this.adminService.manageMOUDialog(orgData.id);
    }
  }

  openManageAdminList() {
    const selectedOrg = localStorage.getItem('SelectedOrgForRevision');
    if (selectedOrg) {
      const orgData = JSON.parse(selectedOrg);
      this.adminService.manageAdminDialog(orgData.id);
    }
  }

  navigatetotab1() {
    if (this.currentRoute.includes('org-mou/')) {
      this.navigateToEditOrg();
    } else if (this.currentRoute.includes('org-admin/')) {
      this.navigateToEditOrg();
    } else {
      window.history.back();
    }
  }

  navigateToDeals() {
    this.router.navigate(['/Customer/Customer/Deals']);
  }

  navigateToOpportunities() {
    this.router.navigate(['/Customer/Customer/Opportunities']);
  }

  isDealsRoute(): boolean {
    return this.currentRoute.includes('/Customer/Customer/Deals/');
  }

  isOpportunitiesRoute(): boolean {
    return this.currentRoute.includes('/Customer/Customer/Opportunities/');
  }

  isPair(id: number): boolean {
    return !(id % 2);
  }

  getExtension(filename: any) {
    const parts = filename.split('.');
    return parts[parts.length - 1];
  }

  isImage(filename: any) {
    const ext = this.getExtension(filename);
    switch (ext.toLowerCase()) {
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'bmp':
      case 'png':
        return true;
    }
    return false;
  }

  home() {
    this.router.navigate(['/'])
  }

  // Check if a change should be displayed as "Created" instead of "Updated"
  shouldShowAsCreated(oldVal: any, newVal: any): boolean {
    // Check if old value is empty/null and new value has content
    const isOldEmpty = oldVal == null || oldVal === '' || 
                       (typeof oldVal === 'object' && Object.keys(oldVal).length === 0);
    const isNewEmpty = newVal == null || newVal === '' || 
                       (typeof newVal === 'object' && Object.keys(newVal).length === 0);
    
    // If old value is empty/null and new value has content, show as Created
    return isOldEmpty && !isNewEmpty;
  }

  // Check if a field is metadata/technical field
  private isMetadataField(label: string): boolean {
    const metadataFields = ['modified date', 'modified time', 'updated date', 'updated time', 'created date', 'created time'];
    return metadataFields.some(field => label.toLowerCase().includes(field));
  }

  // Check if all content items in an Updated block should be shown as Created
  shouldShowUpdatedAsCreated(contentArray: any[]): boolean {
    if (this.currentRoute && this.currentRoute.toLowerCase().includes('api-integration')) {
  return false;
}
    if (!contentArray || contentArray.length === 0) {
      return false;
    }

    if (this.currentRoute && this.currentRoute.includes('AssessmentPlan/')) {
      const statusField = contentArray.find((con: any) => con.label === 'Status');
      const candidatesField = contentArray.find((con: any) => con.label === 'Candidates');
      const isDraftToPublished = statusField && statusField.oldValue === 'Draft' && statusField.newValue === 'Published';
      const isCandidatesFirstTime = candidatesField && (candidatesField.oldValue == null || candidatesField.oldValue === '');
      if (isDraftToPublished && isCandidatesFirstTime) {
        return true;
      }
    }

    // Filter out metadata fields (like Modified Date&Time)
    const importantFields = contentArray.filter(con => !this.isMetadataField(con.label));
    
    // If no important fields, check all
    if (importantFields.length === 0) {
      return contentArray.every(con => this.shouldShowAsCreated(con.oldValue, con.newValue));
    }

    const hasUpdate = importantFields.some(con => {
      const oldEmpty = con.oldValue == null || con.oldValue === '' || con.oldValue === 'No labels';
      const newEmpty = con.newValue == null || con.newValue === '';
      return !oldEmpty && !newEmpty;
    });
    if (hasUpdate) return false;

    // Check if any important field is a created-type change (old empty, new has value)
    // If at least one important field is created-type, show as Created
    return importantFields.some(con => this.shouldShowAsCreated(con.oldValue, con.newValue)) &&
           importantFields.every(con => 
             this.shouldShowAsCreated(con.oldValue, con.newValue) || 
             this.hasChanges(con.oldValue, con.newValue, con.label)
           );
  }

  hasChanges(oldVal: any, newVal: any,label: string): boolean {
    // Don't show technical fields like ID as changes
    const lowerLabel = label.toLowerCase();
    if (lowerLabel === 'id' ||
        lowerLabel.includes('created date') ||
        lowerLabel.includes('created time')) {
      return false;
    }

    if (label === 'Contact Email Id') {
      return true;
    }

    // Check if both values are empty/null
    const isOldEmpty = oldVal == null || oldVal === '' || (typeof oldVal === 'object' && Object.keys(oldVal).length === 0);
    const isNewEmpty = newVal == null || newVal === '' || (typeof newVal === 'object' && Object.keys(newVal).length === 0);
    
    // Both are empty - no change
    if (isOldEmpty && isNewEmpty) {
      return false;
    }

    // If new value is empty but old value has something, don't show it as a change
    if (!isOldEmpty && isNewEmpty) {
      return false;
    }

    // Handle string comparison with trim for whitespace
    if (typeof oldVal === 'string' && typeof newVal === 'string') {
      const trimmedOld = oldVal.trim();
      const trimmedNew = newVal.trim();
      
      // If strings are identical after trimming, there's no change
      if (trimmedOld === trimmedNew) {
        return false;
      }
      return true;
    }

    // Handle array comparison - deeply compare arrays
    if (Array.isArray(oldVal) && Array.isArray(newVal)) {
      // If both arrays are empty, no change
      if (oldVal.length === 0 && newVal.length === 0) {
        return false;
      }
      
      // Deep comparison of arrays
      return JSON.stringify(this.sortAndStringify(oldVal)) !== JSON.stringify(this.sortAndStringify(newVal));
    }

    // Handle object comparison
    if (typeof oldVal === 'object' && oldVal !== null && typeof newVal === 'object' && newVal !== null) {
      try {
        // Deep comparison of objects
        return JSON.stringify(this.sortAndStringify(oldVal)) !== JSON.stringify(this.sortAndStringify(newVal));
      } catch {
        return oldVal !== newVal;
      }
    }

    // Default comparison
    return oldVal !== newVal;
  }

  // Helper method to sort and stringify for consistent comparison
  private sortAndStringify(value: any): any {
    if (Array.isArray(value)) {
      return value.map(item => this.sortAndStringify(item)).sort();
    }
    if (typeof value === 'object' && value !== null) {
      const sorted: any = {};
      Object.keys(value).sort().forEach(key => {
        sorted[key] = this.sortAndStringify(value[key]);
      });
      return sorted;
    }
    return value;
  }

  previewFile(filename: any, isOrg: any, downloadPrefix: string = '') {
    if (typeof filename === 'string' && filename.startsWith('http')) {
      const rawName = filename.split('/').pop()?.split('?')[0] || 'download';
      const downloadName = downloadPrefix + rawName;
      fetch(filename)
        .then(r => r.blob())
        .then(blob => {
          const objectUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = objectUrl;
          a.download = downloadName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(objectUrl);
          document.body.removeChild(a);
        })
        .catch(() => { window.location.href = filename; });
      return;
    }
    // If it's an S3 key (not a URL), generate a fresh signed URL and download
    if (typeof filename === 'string' && filename.length > 0) {
      this.api.post(URL.ADMIN.signedUrl, { requestBody: { fileKeys: [filename] } }).subscribe((resp: any) => {
        const signedUrl = resp?.body?.responseBody?.signedUrls?.[filename];
        if (signedUrl) {
          const rawName = filename.split('/').pop() || 'download';
          const downloadName = "candidate-" + rawName;
          fetch(signedUrl)
            .then(r => r.blob())
            .then(blob => {
              const objectUrl = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = objectUrl;
              a.download = downloadName;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(objectUrl);
              document.body.removeChild(a);
            })
            .catch(() => { window.location.href = signedUrl; });
        }
      });
      return;
    }
    if (this.isImage(filename)) {
      let logoFile: any;
      const isOrgLogo = isOrg ? JSON.parse(isOrg) : false;
      if (isOrgLogo) {
        const [logoHost, logoFileName] = filename.split('/logo/');
      } else {
      }
      window.open(logoFile, '_blank');
    } else {
      let mouFile: any;
      const isOrgMou = isOrg ? JSON.parse(isOrg) : false;
      if (isOrgMou) {
        const [mouHost, mouFileName] = filename.split('/mou/');
      } else {
      }
      window.open(mouFile, '_blank');
    }
  }

  viewMouFile(key: string) {
    if (!key) return;
    this.adminService.download({ key }).subscribe(
      (data: any) => {
        const url = data?.body?.responseBody?.url;
        if (url) {
          window.open(url, '_blank');
        }
      },
      (err: any) => {
        this.util.errorNotification(err);
      }
    );
  }

  isAssessmentPlanRoute(): boolean {
    return this.currentRoute.includes('AssessmentPlan/');
  }

  isusercetorgyRoute(): boolean {
    return this.currentRoute.includes('UserSettings/UserCategory');
  }

  formatAssessmentRules(rules: any): string[] {
    if (!rules) return ['None'];

    const formattedRules: string[] = [];

    for (const [key, value] of Object.entries(rules)) {
      if (Array.isArray(value)) continue;

      const formattedKey = this.formatFieldName(key);
      let formattedValue = value;

      if (typeof value === 'boolean') {
        formattedValue = value ? 'Yes' : 'No';
      } else if (value === null || value === undefined) {
        formattedValue = 'None';
      } else if (value === '') {
        formattedValue = 'Empty';
      } else if (typeof value === 'object') {
        // Flatten nested object into "key: value" pairs
        const pairs = Object.entries(value as object).map(([k, v]) => {
          if (typeof v === 'boolean') return `${this.formatFieldName(k)}: ${v ? 'Yes' : 'No'}`;
          if (v === null || v === undefined) return `${this.formatFieldName(k)}: None`;
          if (Array.isArray(v)) return `${this.formatFieldName(k)}: ${(v as any[]).join(', ') || 'None'}`;
          return `${this.formatFieldName(k)}: ${v}`;
        });
        formattedValue = pairs.length ? pairs.join(', ') : 'None';
      }

      formattedRules.push(`• ${formattedKey}: ${formattedValue}`);
    }

    if (rules.languages && Array.isArray(rules.languages)) {
      formattedRules.push(`• Languages: ${rules.languages.join(', ') || 'None'}`);
    }

    if (rules.stakeholders && Array.isArray(rules.stakeholders)) {
      formattedRules.push(`• Stakeholders: ${rules.stakeholders.join(', ') || 'None'}`);
    }

    return formattedRules;
  }

  getVisibleAssessmentRules(value: any, idx: number, type: 'old' | 'new'): string[] {
    const allRules = this.formatAssessmentRules(value);
    return allRules.slice(0, 5);
  }

  getHiddenAssessmentRules(value: any, idx: number, type: 'old' | 'new'): string[] {
    const allRules = this.formatAssessmentRules(value);
    return allRules.slice(5);
  }

  // New method to get only changed rules
  getOnlyChangedRules(oldRules: any, newRules: any): { oldChanged: string[], newChanged: string[] } {
    // If oldRules is null/empty and newRules has content, show nothing in old, all in new
    const oldIsEmpty = !oldRules || (typeof oldRules === 'string' && oldRules.trim() === '') || 
                       (typeof oldRules === 'object' && Object.keys(oldRules).length === 0);
    const newIsEmpty = !newRules || (typeof newRules === 'string' && newRules.trim() === '') || 
                       (typeof newRules === 'object' && Object.keys(newRules).length === 0);

    const oldFormatted = oldIsEmpty ? [] : this.formatAssessmentRules(oldRules);
    const newFormatted = newIsEmpty ? [] : this.formatAssessmentRules(newRules);

    // Create maps for comparison
    const oldMap = new Map<string, string>();
    const newMap = new Map<string, string>();

    // Parse old rules into map
    oldFormatted.forEach(rule => {
      const match = rule.match(/• ([^:]+):\s*(.*)/);
      if (match) {
        oldMap.set(match[1].trim(), match[2].trim());
      }
    });

    // Parse new rules into map
    newFormatted.forEach(rule => {
      const match = rule.match(/• ([^:]+):\s*(.*)/);
      if (match) {
        newMap.set(match[1].trim(), match[2].trim());
      }
    });

    // Find changed rules - only include if value actually changed
    const changedRules: string[] = [];
    
    // Check for changed or new keys
    const allKeys = new Set([...oldMap.keys(), ...newMap.keys()]);
    allKeys.forEach(key => {
      const oldVal = oldMap.get(key);
      const newVal = newMap.get(key);
      
      // Only include if values are different (considering undefined as empty value)
      const oldValNormalized = oldVal === undefined || oldVal === 'Empty' || oldVal === 'None' ? '' : oldVal;
      const newValNormalized = newVal === undefined || newVal === 'Empty' || newVal === 'None' ? '' : newVal;
      
      if (oldValNormalized !== newValNormalized) {
        changedRules.push(key);
      }
    });

    // Build changed rules display
    const oldChanged: string[] = [];
    const newChanged: string[] = [];

    changedRules.forEach(key => {
      const oldVal = oldMap.get(key);
      const newVal = newMap.get(key);

      if (oldVal !== undefined) {
        oldChanged.push(`• ${key}: ${oldVal}`);
      }
      if (newVal !== undefined) {
        newChanged.push(`• ${key}: ${newVal}`);
      }
    });

    return { oldChanged, newChanged };
  }

  // Methods to get visible changed rules for old value
  getVisibleChangedOldRules(oldRules: any, newRules: any): string[] {
    const changed = this.getOnlyChangedRules(oldRules, newRules);
    return changed.oldChanged.slice(0, 5);
  }

  // Methods to get hidden changed rules for old value
  getHiddenChangedOldRules(oldRules: any, newRules: any): string[] {
    const changed = this.getOnlyChangedRules(oldRules, newRules);
    return changed.oldChanged.slice(5);
  }

  // Methods to get visible changed rules for new value
  getVisibleChangedNewRules(oldRules: any, newRules: any): string[] {
    const changed = this.getOnlyChangedRules(oldRules, newRules);
    return changed.newChanged.slice(0, 5);
  }

  // Methods to get hidden changed rules for new value
  getHiddenChangedNewRules(oldRules: any, newRules: any): string[] {
    const changed = this.getOnlyChangedRules(oldRules, newRules);
    return changed.newChanged.slice(5);
  }

  // Check if there are hidden changed rules
  hasHiddenChangedRules(oldRules: any, newRules: any): boolean {
    const changed = this.getOnlyChangedRules(oldRules, newRules);
    return changed.oldChanged.length > 5 || changed.newChanged.length > 5;
  }

  hasHiddenAssessmentRules(value: any): boolean {
    const allRules = this.formatAssessmentRules(value);
    return allRules.length > 5;
  }

  toggleFilterBox() {
    this.showFilterBox = !this.showFilterBox;
    if (this.showFilterBox) {
      this.populateUserList();
    }
  }

  populateUserList() {
    const users = new Set<string>();
    if (!this.originalData) this.originalData = this.data;

    Object.entries(this.originalData || {}).forEach(([key, events]: [string, any]) => {
      const keyUser = key.split(':')[0];
      if (keyUser) users.add(keyUser);

      (events as any[]).forEach(ev => {
        if (ev && ev.user) users.add(ev.user);
        if (ev && ev.content && typeof ev.content === 'object') {
          if (ev.content.user) users.add(ev.content.user);
          if (ev.content.created_by) users.add(ev.content.created_by);
        }
      });
    });

    this.filteredUserList = Array.from(users).sort();
  }

  onUserSearch() {
    this.populateUserList();
    if (this.userSearch) {
      this.filteredUserList = this.filteredUserList.filter(u =>
        u.toLowerCase().includes(this.userSearch.toLowerCase())
      );
    }
    if (this.userSearch !== this.selectedUser) {
      this.selectedUser = '';
    }
  }

  selectUser(user: string) {
    this.selectedUser = user;
    this.userSearch = user;
    this.applyFilters();
  }

  clearUserFilter() {
    this.selectedUser = '';
    this.userSearch = '';
    this.activeFilterCount = this.selectedDateRange ? 1 : 0;
    this.applyFilters();
  }

  resetDateInputs() {
    this.exactDate = '';
    this.startDate = '';
    this.endDate = '';
  }

  clearDateFilter() {
    this.exactDate = '';
    this.startDate = '';
    this.endDate = '';
    this.selectedDateRange = '';
    this.activeFilterCount = (this.selectedUser || this.userSearch) ? 1 : 0;
    this.applyFilters();
  }

  clearAllFilters() {
    this.selectedUser = '';
    this.userSearch = '';
    this.exactDate = '';
    this.startDate = '';
    this.endDate = '';
    this.selectedDateRange = '';
    this.showFilterBox = false;
    this.activeFilterCount = 0;
    this.data = this.originalData ? { ...this.originalData } : this.data;
    this.cdr.markForCheck();
  }

  applyFilters() {
    if (!this.originalData) this.originalData = this.data;
    let filtered: { [key: string]: TimelineEvent[] } = {};

    const userFilter = (this.selectedUser || this.userSearch).trim().toLowerCase();

    const dateMatch = (dateStr: string) => {
      if (!dateStr) return false;
      try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return false;

        if (this.dateFilterType === 'exact' && this.exactDate) {
          return date.toISOString().slice(0, 10) === this.exactDate;
        }
        if (this.dateFilterType === 'range' && this.startDate && this.endDate) {
          const start = new Date(this.startDate);
          const end = new Date(this.endDate);
          return date >= start && date <= end;
        }
        return true;
      } catch {
        return false;
      }
    };

    Object.entries(this.originalData || {}).forEach(([key, events]: [string, TimelineEvent[]]) => {
      const [keyUser, keyDateStr] = key.split(':');

      let keyDateIso = '';
      if (keyDateStr) {
        try {
          const [yyyy, mmm, dd] = keyDateStr.split('-');
          const month = ('JanFebMarAprMayJunJulAugSepOctNovDec'.indexOf(mmm) / 3 + 1).toString().padStart(2, '0');
          keyDateIso = `${yyyy}-${month}-${dd}`;
        } catch { }
      }

      const filteredEvents = (events || []).filter(ev => {
        const eventUser =
          ev.user ||
          (ev.content && typeof ev.content === 'object' && ev.content !== null && (ev.content as any).user) ||
          (ev.content && typeof ev.content === 'object' && ev.content !== null && (ev.content as any).created_by) ||
          keyUser ||
          '';

        let eventDate = '';
        if (ev.date) {
          eventDate = ev.date;
        } else if ((ev as any).created_datetime) {
          eventDate = (ev as any).created_datetime;
        } else {
          eventDate = keyDateIso;
        }

        const userOk = !userFilter || (eventUser && eventUser.toLowerCase().includes(userFilter));

        let dateOk = true;
        if (this.exactDate || (this.startDate && this.endDate)) {
          dateOk = dateMatch(eventDate);
        }

        return userOk && dateOk;
      });

      if (filteredEvents.length > 0) {
        filtered[key] = filteredEvents;
      }
    });

    if (this.dateFilterType === 'exact' && this.exactDate) {
      this.selectedDateRange = this.exactDate;
    } else if (this.dateFilterType === 'range' && this.startDate && this.endDate) {
      this.selectedDateRange = `${this.startDate} to ${this.endDate}`;
    } else {
      this.selectedDateRange = '';
    }

    this.activeFilterCount = (userFilter ? 1 : 0) + (this.selectedDateRange ? 1 : 0);

    this.data = filtered;
    this.cdr.markForCheck();
    this.showFilterBox = false;
  }

  rulesExpandState: { [key: string]: number } = {};
  creationRulesExpanded: boolean = false;
  rulesCreationExpanded: { [key: string]: boolean } = {};

  getVisibleRules(rules: string[], idx: number): string[] {
    const count = this.rulesExpandState[idx] || 4;
    return rules.slice(0, count);
  }

  hasMoreRules(rules: string[], idx: number): boolean {
    const count = this.rulesExpandState[idx] || 4;
    return rules.length > count;
  }

  toggleRules(idx: number, rules: string[]) {
    const count = this.rulesExpandState[idx] || 4;
    if (count < rules.length) {
      this.rulesExpandState[idx] = Math.min(count + 4, rules.length);
    } else {
      this.rulesExpandState[idx] = 4;
    }
  }

  toggleRulesForCreation() {
    this.creationRulesExpanded = !this.creationRulesExpanded;
    this.cdr.markForCheck();
  }

  toggleCreationRules() {
    this.creationRulesExpanded = !this.creationRulesExpanded;
    this.cdr.markForCheck();
  }

  onRulesSeeMoreClick(contentKey: string, event: Event): void {
    event.preventDefault();
    this.rulesCreationExpanded[contentKey] = !this.rulesCreationExpanded[contentKey];
    this.cdr.markForCheck();
  }

  hasRulesInCreation(content: any): boolean {
    try {
      const data = typeof content === 'string' ? JSON.parse(content) : content;
      return data && data.rules && typeof data.rules === 'object';
    } catch (e) {
      return false;
    }
  }

  getVisibleCreationRules(content: any): string[] {
    try {
      const data = typeof content === 'string' ? JSON.parse(content) : content;
      if (!data || !data.rules) return [];

      const formattedRules = this.formatAssessmentRules(data.rules);
      return formattedRules.slice(0, 4);
    } catch (e) {
      return [];
    }
  }

  getHiddenCreationRules(content: any): string[] {
    try {
      const data = typeof content === 'string' ? JSON.parse(content) : content;
      if (!data || !data.rules) return [];

      const formattedRules = this.formatAssessmentRules(data.rules);
      return formattedRules.slice(4);
    } catch (e) {
      return [];
    }
  }

  hasHiddenCreationRules(content: any): boolean {
    try {
      const data = typeof content === 'string' ? JSON.parse(content) : content;
      if (!data || !data.rules) return false;

      const formattedRules = this.formatAssessmentRules(data.rules);
      return formattedRules.length > 4;
    } catch (e) {
      return false;
    }
  }

  getOtherCreationFields(content: any): any[] {
    try {
      const data = typeof content === 'string' ? JSON.parse(content) : content;
      if (!data || !this.isObject(data)) return [];

      const fields = [];
      const TECHNICAL_FIELDS = ['created_by', 'modified_by', 'created_at', 'updated_at'];
      const MEANINGFUL_ID_FIELDS = ['parent_question_id'];

      for (const [key, value] of Object.entries(data)) {
        if (key === 'rules' ||
          key === 'id' ||
          key === 'version_id' || // Hide version_id, show version_name instead
          (key.endsWith('_id') && !MEANINGFUL_ID_FIELDS.includes(key)) ||
          key.endsWith('_ids') ||
          TECHNICAL_FIELDS.includes(key)) continue;

        if (value === null || value === undefined || value === '') continue;

        fields.push({
          label: this.formatFieldName(key),
          value: this.formatValue(key, value)
        });
      }

      return fields;
    } catch (e) {
      return [];
    }
  }

  private isTechnicalOrIdField(label: string): boolean {
    if (!label) return false;
    const normalized = label.replace(/\s+/g, '_').toLowerCase();

    const TECHNICAL_FIELDS = ['created_by', 'modified_by', 'created_at', 'updated_at'];
    const MEANINGFUL_ID_FIELDS = ['version_id', 'course_id', 'parent_question_id'];
    return (
      normalized === 'id' ||
      (normalized.endsWith('_id') && !MEANINGFUL_ID_FIELDS.includes(normalized)) ||
      normalized.endsWith('_ids') ||
      TECHNICAL_FIELDS.includes(normalized)
    );
  }

  private normalizeContent(content: any): any {
    return {
      id: content?.id,
      title: content?.title,
      email: content?.['Created User Email']
    };
  }

  removeDuplicateCreated(events: any[]): any[] {
    // Never filter out 'Updated' events - they should always show separately
    // Only filter out duplicate 'Created' events (same id, title, email)
    const seen = new Set();
    const result: any[] = [];
    let createdEventFound = false;

    for (const event of events) {
      if (event.title !== 'Created') {
        // Always include Updated and other event types
        result.push(event);
      } else {
        // For Created events, only keep the first one with unique normalized content
        const norm = this.normalizeContent(event.content);
        const key = JSON.stringify(norm);
        if (!seen.has(key)) {
          result.push(event);
          seen.add(key);
          createdEventFound = true;
        }
      }
    }

    return result;
  }

  hasAnyRealChanges(content: any[]): boolean {
    if (!Array.isArray(content)) return false;
    // Filter out "Modified Date&Time" and only check real field changes
    return content.some(con =>
      this.hasChanges(con.oldValue, con.newValue, con.label) &&
      !con.label?.toLowerCase().includes('modified date')
    );
  }

  hasGroupRealChanges(objectItem: any): boolean {
    if (!objectItem?.value || !Array.isArray(objectItem.value)) return false;
    return objectItem.value.some((item: any) =>
      item.title !== 'Updated' || this.hasAnyRealChanges(item.content)
    );
  }

  shouldShowCreatedSection(objectItem: any): boolean {
    // For Assessment Plans, hide Created section if there are any Updated sections with real changes
    if (this.currentRoute?.includes('AssessmentPlan/')) {
      const hasUpdatedSection = objectItem?.value?.some((item: any) =>
        item.title === 'Updated' && this.hasAnyRealChanges(item.content)
      );
      // Hide Created if there's an Updated section with real changes
      return !hasUpdatedSection;
    }
    // For other routes, always show Created
    return true;
  }

  isPasswordField(label: string): boolean {
    if (!label) return false;
    return label.toLowerCase().includes('password');
  }

  // Get display text for password field
  getPasswordDisplayText(oldValue: any, newValue: any): string {
    const oldIsEmpty = oldValue == null || oldValue === '' || 
                       (typeof oldValue === 'object' && Object.keys(oldValue).length === 0);
    const newIsEmpty = newValue == null || newValue === '' || 
                       (typeof newValue === 'object' && Object.keys(newValue).length === 0);
    
    // If old is empty and new has value = Created
    if (oldIsEmpty && !newIsEmpty) {
      return 'Password Created';
    }
    // If both have values = Updated
    if (!oldIsEmpty && !newIsEmpty) {
      return 'Password Updated';
    }
    if (!oldIsEmpty && newIsEmpty) {
      return 'Password Removed';
    }
    return 'Password';
  }

}